import React, { useEffect } from 'react'
import styles from "./MoveRecipients.styles"

import VerticalSeparator from '../../../components/separator/verticalseparator/VerticalSeparator'
import Loadable from '../../../components/loadable/Loadable'
import Heading from '../../../components/heading/Heading'

import { componentKey as recipientSectionKey, setPayersPaginationState, setSelectedPayer } from '../RecipientsSectionSlice';
import { componentKey, setDeleteRecipientsModal, setHighlightedRecipient, setMoveRecipientsConfirmationModalOpen, setPaginationState, setPayerDropdownPagination, setSearchOption, setSelectPayerModalOpen, setSelectedRecipients, setShouldReloadRecipientList } from "./MoveRecipientsSlice"
import { useDispatch, useSelector } from 'react-redux'
import { deleteRecipients, getRecipientLists, switchRecipients } from './MoveRecipientsSaga'

import { PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../constants/constants'
import { HEADING } from '../../../components/heading/constants/constants'
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants'
import { addNotifications } from '../../toaster/ToasterPortalSlice'
import { BUTTON_TYPE } from '../../../components/button/constants'

import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown'
import TextInput from '../../../components/input/textinput/TextInput'
import RichGrid from '../../../components/richgrid/RichGrid'
import Label from '../../../components/label/Label'
import Icons from '../../../components/icons/Icons'
import Button from '../../../components/button/Button'
import ConfirmationPopup from '../../../components/popup/confirmationpopup/ConfirmationPopup'
import Payer from '../../../../libs/utility/Payer'
import SelectPayerModal from './custommodal/SelectPayerModal'
import { getPaginatedPayersList } from '../RecipientsSectionSaga'
import { useState } from 'react';
import { RECIPIENT_SECTION_ROUTES } from '../constants'
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs'


const MoveRecipients = () => {
    const dispatch = useDispatch()

    const { loadingState, searchOption, paginationState, recipientsList, selectedRecipients, deleteRecipientsModal, highlightedRecipient, moveRecipientsConfirmationModalOpen, selectPayerModalOpen, shouldReloadRecipientList,payerDropdownPagination } = useSelector(state => state[componentKey])

    const { payersList, payersPaginationState, selectedPayer } = useSelector(state => state[recipientSectionKey]);

    const [paginatedPayerList, setPaginatedPayerList] = useState([]);

    useEffect(() => {
        dispatch(getRecipientLists(paginationState))
        dispatch(getPaginatedPayersList({...payersPaginationState, selectedPayer}));
    }, [])

    useEffect(() => {
        if(shouldReloadRecipientList){
            dispatch(getRecipientLists(paginationState));
            dispatch(setShouldReloadRecipientList(false));
        }
    }, [shouldReloadRecipientList])

    useEffect(() => {
        setPaginatedPayerList(payersList)
    }, [payersList])

    const MOVE_RECIPIENTS_COLUMNS = [
        {
            field: "Payer Name",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text, ...styles.date }}>Payer Name</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text, ...styles.date }}>{row.PayerName}</span>
        },
        {
            field: "Recipient Name",
            header: <Label weight={LABEL_WEIGHT[700]}>Recipient Name</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.FirstName || ''} {row.LastName}</span>
        },
        {
            field: "Address 1",
            header: <Label weight={LABEL_WEIGHT[700]}>Address 1</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.Address1}</span>
        },
        {
            field: "Tax ID",
            header: <Label weight={LABEL_WEIGHT[700]}>Tax ID</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{Payer.getPayerTINByIdType(row.IdType, row.IdNumber, true)}</span>
        },
        {
            field: "City",
            header: <Label weight={LABEL_WEIGHT[700]}>City</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.City}</span>
        },
        {
            field: "action",
            header: <Label weight={LABEL_WEIGHT[700]}>Action</Label>,
            renderLogic: (row, idx) => <span style={styles.action}>
                <div
                    onClick={() => {
                        dispatch(setHighlightedRecipient(row))
                        dispatch(setDeleteRecipientsModal(true))
                    }}
                >
                    <Icons familyName='vec' style={styles.deleteIconStyle} iconName={VEC_ICON_NAME.DELETE_ICON} />
                </div>
                <div
                    onClick={() => {
                        dispatch(setHighlightedRecipient(row))
                        dispatch(setMoveRecipientsConfirmationModalOpen(true))
                    }}
                >
                    <Icons familyName='vec' style={styles.iconStyle} iconName={VEC_ICON_NAME.COPY_ICON} />
                </div>
            </span>
        },
    ];


    return (
        <Loadable currentState={loadingState.state} loadingStates={[PAGE_STATE.LOADING]} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
           <Breadcrumbs items={[
                        { text: 'Home', link: '/' },
                        { text: 'Manage Recipients', link: `/${RECIPIENT_SECTION_ROUTES.RECIPIENT}` },
                        { text: 'Copy Recipients' },
                    ]} 
                />
            {loadingState.state === PAGE_STATE.PAGE_READY &&

                <div style={styles.headerContainer}>

                    <div>
                        <div style={styles.titleAndSearch}>
                            <Heading type={HEADING.H1}>Copy Recipients</Heading>

                            <div style={styles.icons}>

                                <div style={styles.dropdownContainer}>
                                    <SelectDropdown
                                        value={searchOption}
                                        onSelectCb={(name, selectedOption) => dispatch(setSearchOption(selectedOption))}
                                        options={[{ label: "Search by Name", value: "NAME" }, { label: "Search by Tax Id", value: "TAX_ID" }]}
                                        customInputStyles={styles.dropdownInput}
                                        isClearable={false}
                                    />
                                </div>

                                <div style={styles.searchContainer}>

                                    {searchOption.value === "NAME" ?
                                        <TextInput
                                            value={paginationState?.FilterText}
                                            placeHolder="Search by name"
                                            onChangeCb={(e) => dispatch(setPaginationState({ FilterText: e.target.value }))}
                                            suffixProps={{
                                                icon: VEC_ICON_NAME.SEARCH_ICON,
                                                suffixIconCb: () => dispatch(getRecipientLists(
                                                    { ...paginationState, PageNumber: 0, Skip: 0 }
                                                ))
                                            }}
                                        />

                                        :

                                        <TextInput
                                            value={paginationState?.IdNumber}
                                            placeHolder="Search by tax ID"
                                            type="number"
                                            onChangeCb={(e) => dispatch(setPaginationState({ IdNumber: e.target.value }))}
                                            suffixProps={{
                                                icon: VEC_ICON_NAME.SEARCH_ICON,
                                                suffixIconCb: () => dispatch(getRecipientLists(
                                                    { ...paginationState, PageNumber: 0, Skip: 0 }
                                                ))
                                            }}
                                        />
                                    }
                                </div>

                                <VerticalSeparator />

                                <div onClick={() => dispatch(getRecipientLists({ ...paginationState, PageNumber: 0, Skip: 0, IsDesc: !paginationState?.IsDesc }))}>
                                    <Icons familyName='vec' iconName={VEC_ICON_NAME.SORT_ICON} rotateDeg={paginationState?.IsDesc ? 0 : 180} />
                                </div>

                            </div>
                        </div>
                    </div>

                    <div style={styles.action}>

                        <Button
                            style={styles.button}
                            onClickCb={() => {
                                if (selectedRecipients.length) {
                                    dispatch(setDeleteRecipientsModal(true))
                                } else {
                                    dispatch(addNotifications({ heading: "Error", message: "Please Select Recipients to Proceed." }));
                                }
                            }}
                        >Delete Recipients</Button>

                        <Button
                            style={styles.button}
                            onClickCb={() => {
                                if (selectedRecipients.length) {
                                    dispatch(setMoveRecipientsConfirmationModalOpen(true))
                                } else {
                                    dispatch(addNotifications({ heading: "Error", message: "Please Select Recipients to Proceed." }));
                                }
                            }}
                        >Copy Recipient(s) to Another Payer</Button>
                    </div>

                    {recipientsList?.length ?
                        <>
                            <div style={styles.mainContainer}>

                                <RichGrid
                                    selectable={true}
                                    data={recipientsList}
                                    selectedRows={selectedRecipients}
                                    columns={MOVE_RECIPIENTS_COLUMNS}
                                    extractRowKey={(row) => row.RecipentDetailId}
                                    onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setSelectedRecipients(selectedData))}
                                    onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedRecipients(selectedData))}
                                    paginationProps={{
                                        skip: paginationState?.Skip,
                                        take: paginationState?.PageSize,
                                        takeOptions: ROW_SELECTION_OPTIONS,
                                        total: paginationState?.totalRecipients,
                                        onChangeTakeCb: (newTake) => {
                                            dispatch(getRecipientLists({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }))
                                            dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                                        },
                                        onChange: (take, skip) => {
                                            dispatch(getRecipientLists({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                                            dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                                        }
                                    }}
                                />
                            </div>
                        </>

                        :

                        <div style={styles.noPayersFoundContainer}>
                            <Heading type={HEADING.H2}>No Recipients Found</Heading>
                        </div>
                    }


                    <ConfirmationPopup
                        title='Are you sure?'
                        bodyText='Only recipients with no forms attached will be deleted. Do you want to continue ?'
                        iconName={VEC_ICON_NAME.WARNING_ICON}
                        isOpen={deleteRecipientsModal}
                        confirmationButtonProps={{
                            onConfirmationCb: () => {
                                let data = { PayerId: selectedRecipients.length ? selectedRecipients[0].PayerId : highlightedRecipient.PayerId, RecipientIds: selectedRecipients.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient.RecipentDetailId] }
                                dispatch(deleteRecipients(data))
                            },
                            confirmationButtonText: "Proceed",
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.PRIMARY,
                        }}
                        cancelButtonProps={{
                            onCancelCb: () => {
                                dispatch(setDeleteRecipientsModal(false))
                            },
                            cancelButtonText: "Cancel",
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        }}
                        customStyle={styles.tinMatchPopup}
                    />

                    <ConfirmationPopup
                        title='Are you sure?'
                        bodyText='Are you sure you want to add these recipient(s) to another Payer?'
                        iconName={VEC_ICON_NAME.WARNING_ICON}
                        isOpen={moveRecipientsConfirmationModalOpen}
                        confirmationButtonProps={{
                            onConfirmationCb: () => {
                                dispatch(setSelectPayerModalOpen(true))
                                dispatch(setMoveRecipientsConfirmationModalOpen(false))
                            },
                            confirmationButtonText: "Proceed",
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.PRIMARY,
                        }}
                        cancelButtonProps={{
                            onCancelCb: () => {
                                dispatch(setMoveRecipientsConfirmationModalOpen(false))
                            },
                            cancelButtonText: "Cancel",
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        }}
                        customStyle={styles.tinMatchPopup}
                    />

                    <SelectPayerModal
                        title="Add Recipients to Another Payer"
                        isOpen={selectPayerModalOpen}
                        value={selectedPayer}
                        bodyText="Select Payer to Move"
                        confirmationButtonProps={{
                            onConfirmationCb: () => {
                                if (selectedPayer) {
                                    let data = { PayerId: selectedPayer.PayerDetailId, RecipientIds: selectedRecipients.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient.RecipentDetailId] }
                                    dispatch(switchRecipients(data))
                                } else {
                                    dispatch(addNotifications({ heading: "Error", message:"Please Select Payer To Proceed." }));
                                }
                            },
                            confirmationButtonText: "Ok",
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.PRIMARY,
                        }}
                        cancelButtonProps={{
                            onCancelCb: () => {
                                dispatch(setSelectPayerModalOpen(false))
                            },
                            cancelButtonText: "Cancel",
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        }}
                        name="payer"
                        placeHolder="Select payer"
                        options={paginatedPayerList.slice(0, payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber))}
                        onSearchInputChangeCb={(searchText) => {
                            dispatch(setPayersPaginationState({ ...payersPaginationState, FilterText: searchText.target.value }))
                            dispatch(getPaginatedPayersList({ ...payersPaginationState, PageNumber: 1, FilterText: searchText.target.value, selectedPayer }))
                        }}


                        onDropdownTouchedToBottomCb={() => {
                            if(payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber) < paginatedPayerList?.length){   
                                dispatch(setPayerDropdownPagination({ PageNumber: payerDropdownPagination.PageNumber + 1 }))
                            }
                        }}
                        clearSearchTextCb={() => {
                            dispatch(setPayersPaginationState({ ...payersPaginationState, FilterText: "", IdNumber: "" }))
                        }}
                        onSelectCb={(name, selectedOption) => dispatch(setSelectedPayer(selectedOption))}
                    />

                </div>}
        </Loadable >
    )
}

export default MoveRecipients
